import React, { useRef, useState } from 'react'
import { pdfjs, Document, Page } from 'react-pdf'
import { SizeMe } from 'react-sizeme'
import { useReactToPrint } from 'react-to-print'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint, faTimes } from '@fortawesome/free-solid-svg-icons'

import { Watermark } from "antd"

// using ES6 modules
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'

import styles from './styles.module.scss'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

const ViewPDF = ({ isWatermarkDisabled, isDisplayingPrint, data, url, files, text, onPrintedComplete, onClose }) => {
  const [numPages, setNumPages] = useState(null)
  const [isPrinting, setIsPrinting] = useState(false)

  const handlePrint = useReactToPrint({
    onBeforePrint: () => setIsPrinting(true),
    content: () => componentRef.current,
    onAfterPrint: () => {
      if (onPrintedComplete) onPrintedComplete(data) 
      setIsPrinting(false)
      onClose()
    },
    onPrintError: () => onClose(),
    removeAfterPrint: true,
    suppressErrors: true
  });

  const componentRef = useRef();

  const _onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages)
  }

  const _getPages = ({ width, height }) => {
    if (numPages) {
      return Array.apply(null, Array(numPages)).map((itm, key) => {
        return <Page key={key} pageNumber={(key + 1)} width={width} height={height} renderTextLayer={false} />
      })
    }
    return null
  }

  const _getWatermarkContent = () => {
    if (isWatermarkDisabled) return null
    if (isPrinting) {
      return []
    }
    return ['Invalid Unless Printed', 'Financial Casualty']
  }

  if (url) {
    return (
      <>
        <div className={styles.viewPdfModal}>
          <button className={styles.viewPdfModal__close} onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
            <span>Close</span>
          </button>
          <p className="big">{text || "Below is the PDF your Requested"}</p>
          {isDisplayingPrint && (
            <button className={styles.viewPdfModal__print} onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              handlePrint()
            }}>
              <FontAwesomeIcon icon={faPrint} />
              <span>Print</span>
            </button>
          )}
          <Watermark content={_getWatermarkContent()}>
            <SizeMe
              ref={componentRef}
              monitorHeight
              refreshRate={128}
              refreshMode={"debounce"}
              render={({ size }) => (
                <Document
                  file={url}
                  onLoadSuccess={_onDocumentLoadSuccess}
                  className="tester"
                >
                  {_getPages(size)}
                </Document>
              )}
            />
          </Watermark>
        </div>
        <div className={styles.viewPdfModal__container} onClick={onClose}></div>
      </>
    )
  }
  return null
}

export default ViewPDF